/* Piercings & Co — the library hub.
 *
 * Renders the whole library from a generated index (assets/pco-library-index.json, built by
 * publish/build-library-index.mjs). Search, chips, counts and grouping all read that one
 * file, so no number on the page is ever typed by hand and none can drift from the corpus.
 *
 * WHY NOT SHOPIFY PREDICTIVE SEARCH. Measured on this store 26 Aug 2026: page search
 * matches TITLES ONLY. "aftercare" is in 48 page bodies and returns zero page results, and
 * the same is true of titanium, pillow, autoclave and downsizing. Placement and place names
 * work because they sit in titles. A search that finds "helix" but not "aftercare" feels
 * broken, so this searches title, description AND the keywords each page actually leans on.
 *
 * The index is ~56 KB for 58 pages in two languages. That is small enough to hold in memory
 * and search synchronously, so there is no network round trip per keystroke and no stale
 * response to guard against.
 */
(function () {
  var root = document.querySelector('.pcolib');
  if (!root) return;

  var input = root.querySelector('#pcolib-q');
  var clear = root.querySelector('.pcolib__clear');
  var chips = root.querySelector('.pcolib__chips');
  var status = root.querySelector('.pcolib__status');
  var results = root.querySelector('.pcolib__results');
  var library = root.querySelector('.pcolib__library');

  var LOCALE = root.dataset.locale === 'fr' ? 'fr' : 'en';
  var FR = LOCALE === 'fr';
  var LEAD_SLUG = root.dataset.lead || '';

  var T = {
    en: {
      searching: 'Searching…', none: 'Nothing matched ', one: ' guide', many: ' guides',
      matching: ' matching ', lead: 'Start here', go: 'Read it →', all: 'All',
      unavailable: 'The library could not be loaded. Every page is still reachable from the menu.',
      tryShorter: 'Try a shorter word — helix, healing, aftercare, Laval.'
    },
    fr: {
      searching: 'Recherche…', none: 'Aucun résultat pour ', one: ' guide', many: ' guides',
      matching: ' pour ', lead: 'Commencez ici', go: 'Lire →', all: 'Tout',
      unavailable: "La bibliothèque n'a pas pu être chargée. Toutes les pages restent accessibles depuis le menu.",
      tryShorter: 'Essayez un mot plus court — hélix, guérison, entretien, Laval.'
    }
  }[LOCALE];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Accent-insensitive, so "helix" finds "hélix" and "guerison" finds "guérison". Quebec
  // users type both ways and a search that cares about accents fails half of them.
  function fold(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  var ENTRIES = [];
  var CATS = [];
  var activeCat = '';

  function card(e, q) {
    var title = esc(e.t);
    if (q) {
      // Highlight on the folded match position so accented text still highlights correctly.
      var i = fold(e.t).indexOf(q);
      if (i !== -1) {
        title = esc(e.t.slice(0, i)) + '<mark>' + esc(e.t.slice(i, i + q.length)) + '</mark>' + esc(e.t.slice(i + q.length));
      }
    }
    return '<a class="pcolib__card" href="' + esc(e.u) + '">' +
      '<span class="pcolib__card-title">' + title + '</span>' +
      '<span class="pcolib__card-ex">' + esc(e.d) + '</span></a>';
  }

  // Pages whose BODY contains a word starting with the query, from the inverted index.
  // Built once per query rather than per document.
  function bodyMatches(q) {
    var hit = {};
    if (!POST) return hit;
    for (var w in POST) {
      if (w.indexOf(q) !== 0) continue;
      var ids = POST[w];
      for (var i = 0; i < ids.length; i++) hit[ids[i]] = true;
    }
    return hit;
  }

  function score(e, i, q, bodyHit) {
    var t = fold(e.t);
    if (t.indexOf(q) === 0) return 100;
    if (t.indexOf(q) !== -1) return 80;
    if (fold(e.d).indexOf(q) !== -1) return 50;
    if (bodyHit[i]) return 30;
    return 0;
  }

  function renderLibrary() {
    var pool = activeCat ? ENTRIES.filter(function (e) { return e.c === activeCat; }) : ENTRIES;
    var html = '';

    // The lead only shows on the unfiltered view. Inside a category it would push the
    // category's own contents below the fold for no reason.
    var lead = null;
    if (!activeCat && LEAD_SLUG) {
      lead = ENTRIES.filter(function (e) { return e.u.indexOf('/pages/' + LEAD_SLUG) !== -1; })[0] || null;
    }
    if (lead) {
      html += '<a class="pcolib__lead" href="' + esc(lead.u) + '">' +
        '<span class="pcolib__lead-kicker">' + T.lead + '</span>' +
        '<span class="pcolib__lead-title">' + esc(lead.t) + '</span>' +
        '<span class="pcolib__lead-ex">' + esc(lead.d) + '</span>' +
        '<span class="pcolib__lead-go">' + T.go + '</span></a>';
    }

    CATS.forEach(function (c) {
      var inCat = pool.filter(function (e) { return e.c === c.id && e !== lead; });
      if (!inCat.length) return;
      html += '<section class="pcolib__group"><div class="pcolib__secthead">' +
        '<h2>' + esc(c[LOCALE]) + '</h2>' +
        '<span>' + inCat.length + (inCat.length === 1 ? T.one : T.many) + '</span></div>' +
        '<div class="pcolib__grid">' + inCat.map(function (e) { return card(e, ''); }).join('') + '</div></section>';
    });

    library.innerHTML = html;
  }

  function renderChips() {
    var counts = {};
    ENTRIES.forEach(function (e) { counts[e.c] = (counts[e.c] || 0) + 1; });
    var html = '<button class="pcolib__chip" type="button" aria-pressed="true" data-cat="">' +
      T.all + ' <span>' + ENTRIES.length + '</span></button>';
    CATS.forEach(function (c) {
      if (!counts[c.id]) return;   // never render a chip that would filter to nothing
      html += '<button class="pcolib__chip" type="button" aria-pressed="false" data-cat="' + esc(c.id) + '">' +
        esc(c[LOCALE]) + ' <span>' + counts[c.id] + '</span></button>';
    });
    chips.innerHTML = html;
  }

  function search() {
    var raw = input.value.trim();
    clear.hidden = !raw;
    if (raw.length < 2) {
      results.hidden = true;
      results.innerHTML = '';
      library.hidden = false;
      status.textContent = '';
      return;
    }
    var q = fold(raw);
    var bodyHit = bodyMatches(q);
    var hits = ENTRIES
      .map(function (e, i) { return { e: e, s: score(e, i, q, bodyHit) }; })
      .filter(function (x) { return x.s > 0 && (!activeCat || x.e.c === activeCat); })
      .sort(function (a, b) { return b.s - a.s; });

    library.hidden = true;
    results.hidden = false;
    results.innerHTML = hits.length
      ? '<div class="pcolib__grid">' + hits.map(function (x) { return card(x.e, q); }).join('') + '</div>'
      : '<p class="pcolib__notice">' + T.none + '“' + esc(raw) + '”. ' + T.tryShorter + '</p>';
    status.textContent = hits.length
      ? hits.length + (hits.length === 1 ? T.one : T.many) + T.matching + '“' + raw + '”'
      : T.none + '“' + raw + '”';
  }

  chips.addEventListener('click', function (ev) {
    var b = ev.target.closest('.pcolib__chip');
    if (!b) return;
    activeCat = b.dataset.cat || '';
    chips.querySelectorAll('.pcolib__chip').forEach(function (x) {
      x.setAttribute('aria-pressed', String(x === b));
    });
    if (input.value.trim().length >= 2) search();
    else renderLibrary();
  });

  // The postings file is 247 KB and is only needed once somebody types, so it is fetched on
  // first interaction rather than on load. Until it lands, search still works on titles and
  // descriptions; when it lands the current query is re-run so body matches appear.
  var POST = null, postWanted = false;
  function wantPost() {
    if (postWanted) return;
    postWanted = true;
    fetch(root.dataset.post, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { POST = j[LOCALE] || {}; if (input.value.trim().length >= 2) search(); })
      .catch(function () { POST = {}; });
  }

  input.addEventListener('focus', wantPost, { once: true });
  input.addEventListener('input', function () { wantPost(); search(); });
  input.addEventListener('search', search);
  clear.addEventListener('click', function () { input.value = ''; search(); input.focus(); });

  fetch(root.dataset.index, { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      ENTRIES = j[LOCALE] || [];
      CATS = j.cats || [];
      // The placeholder count comes from the index, never from Liquid, so it cannot
      // disagree with what is actually searchable.
      var tpl = input.getAttribute(FR ? 'data-tpl-fr' : 'data-tpl-en') || '';
      input.placeholder = tpl.replace('{n}', ENTRIES.length);
      renderChips();
      renderLibrary();
    })
    .catch(function () {
      library.innerHTML = '<p class="pcolib__notice">' + T.unavailable + '</p>';
      input.placeholder = '';
      input.disabled = true;
    });
})();
